import type { GridApi, ColDef } from 'ag-grid-community'
import { PinColumnsMenu } from './PinColumnsMenu'
import type { RowSize } from './types'

const btnStyle = (active: boolean) => ({
  padding: '4px 10px',
  fontSize: 12,
  border: '1px solid var(--border-strong)',
  borderRadius: 6,
  cursor: 'pointer',
  background: active ? '#2563eb' : 'var(--bg-panel)',
  color: active ? '#fff' : 'var(--text-muted)',
})

const SIZES: { key: RowSize; label: string }[] = [
  { key: 'compact', label: 'Компактный' },
  { key: 'normal', label: 'Стандартный' },
  { key: 'tall', label: 'Высокий' },
]

/**
 * Правая группа действий шапки «Таблицы»: переключатель высоты строк, сброс
 * вида, меню закрепления колонок, кнопка добавления строки. Вынесено из
 * TablePage, чтобы держать файл страницы в пределах лимита 500 строк.
 */
export function TableHeaderActions({
  rowSize,
  onRowSize,
  onReset,
  getApi,
  columnDefs,
  onAddRow,
}: {
  rowSize: RowSize
  onRowSize: (s: RowSize) => void
  onReset: () => void
  getApi: () => GridApi | undefined
  columnDefs: ColDef[]
  onAddRow: () => void
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {SIZES.map(({ key, label }) => (
        <button key={key} onClick={() => onRowSize(key)} style={btnStyle(rowSize === key)}>
          {label}
        </button>
      ))}

      <button onClick={onReset} style={btnStyle(false)}>
        Сброс
      </button>

      <PinColumnsMenu getApi={getApi} columnDefs={columnDefs} />

      <button
        onClick={onAddRow}
        style={{
          padding: '6px 14px',
          fontSize: 13,
          background: '#2563eb',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
          marginLeft: 8,
        }}
      >
        + Добавить строку
      </button>
    </div>
  )
}
